import React from 'react';
import { connect } from 'react-redux';
import GlobalMenu from '@/components/global/menu/GlobalMenu';
import SendCoin from '@/components/contents/send/SendCoin';
import Email from '@/components/contents/user/Email/Email';
import { getLocaleWordContent } from '@/utils/language.util';

function SendPage({ show }) {
    return (
        <div id="wrap" className="main sub_page">
            <div className="inner">
                <GlobalMenu />
                <h2 className="text-center">{getLocaleWordContent('현금 입금')}</h2>
            </div>
            <div className="sp20"></div>
            <div className="deposit">
                <SendCoin />
            </div>

            {show.show === true ? <Email /> : null}
        </div>
    );
}
export default connect(
    (state) => ({
        show: state.widget.getIn(['modal', 'show']),
    }),
    null,
)(SendPage);
